import React, { useState } from 'react';

import { X } from 'lucide-react';

import FormImagesItem from 'common/image/FormImagesItem';
import PhotoViewer from 'common/PhotoViewer';
import Button from 'common/uiV3/Button';
import Dialog from 'common/uiV3/Dialog';

import type { LocalFile } from 'common/constants/files';

import 'css/components/image/_FormImages.scss';

type Props = {
  allowRemove: boolean;
  images: LocalFile[];
  onImageRemoved?: (image: LocalFile) => void;
};

type PhotoViewerState = {
  imageURLs: string[];
  defaultIndex: number;
} | null;

const FormImages = ({ allowRemove, images, onImageRemoved }: Props) => {
  const [open, setOpen] = useState(false);
  const [photoViewerState, setPhotoViewerState] = useState<PhotoViewerState>(null);

  const onImageClicked = (image: LocalFile) => {
    const imageURLs = images
      .reverse()
      .map((image) => image.url)
      .filter((url): url is string => Boolean(url));
    const index = image.url ? imageURLs.indexOf(image.url) : 0;
    setPhotoViewerState({ imageURLs, defaultIndex: index });
    setOpen(true);
  };

  const onClosePhotoViewer = () => {
    setOpen(false);
    setTimeout(() => setPhotoViewerState(null), 300);
  };

  const renderedImages = images.map((image) => {
    return (
      <FormImagesItem
        allowRemove={allowRemove}
        key={image.uniqueID}
        image={image}
        onImageClicked={onImageClicked}
        onImageRemoved={onImageRemoved}
      />
    );
  });

  return (
    <>
      <div className="formImages">{renderedImages}</div>
      <Dialog open={open} onOpenChange={setOpen}>
        <Dialog.Content
          showCloseButton={false}
          className="h-svh w-svw sm:max-w-[100%-2rem] rounded-none bg-transparent border-none items-center justify-center">
          <div className="bg-background rounded absolute top-3.5 right-0">
            <Button variant="outlined" color="primary" onClick={onClosePhotoViewer}>
              <X />
              Close
            </Button>
          </div>
          {photoViewerState && (
            <div className="bg-background p-2 rounded base-border">
              <PhotoViewer
                imageURLs={photoViewerState.imageURLs}
                defaultIndex={photoViewerState.defaultIndex}
                closeModal={onClosePhotoViewer}
              />
            </div>
          )}
        </Dialog.Content>
      </Dialog>
    </>
  );
};

export default FormImages;
